import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import TripBookingCreatePage from './trip-booking-create'
import TripBookingListPage from './trip-booking-list'
import UpdateTripBookingPage from './trip-booking-update'

const tripBookingRoutes: Route[] = [
  {
    path: Paths.TRIP_BOOKING_LIST_PAGE,
    element: <TripBookingListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_BOOKING_CREATE_PAGE,
    element: <TripBookingCreatePage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_BOOKING_UPDATE_PAGE,
    element: <UpdateTripBookingPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default tripBookingRoutes
